import React, { useState } from 'react';
import { Button, Textarea } from '@/components/ui';
import { TelegramUtils } from '@/utils/telegram';
import { useReportUser } from '@/hooks/api';
import { useAppStore } from '@/store';

interface ReportModalProps {
  userId: string;
  userName: string;
  onClose: () => void;
}

const ReportModal: React.FC<ReportModalProps> = ({ userId, userName, onClose }) => {
  const [reason, setReason] = useState('');
  const { showToast } = useAppStore();
  const reportUser = useReportUser({
    onSuccess: () => {
      showToast('Жалоба отправлена. Спасибо за помощь в поддержании безопасности.', 'success');
      onClose();
    },
  });

  const handleSubmit = () => {
    if (!reason.trim()) {
      return;
    }

    console.log('🚨 Sending report:', { userId, reason: reason.trim() });
    reportUser.mutate({ userId, reason: reason.trim() });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/80 backdrop-blur-sm animate-fade-in safe-area-y">
      <div className="w-full max-w-md bg-tg-bg border border-white/10 rounded-3xl p-6 animate-scale-in">
        {/* Header */}
        <div className="mb-6">
          <h2 className="text-2xl font-bold text-white mb-2">
            Пожаловаться
          </h2>
          <p className="text-neutral-400 text-sm">
            Жалоба на пользователя {userName}
          </p>
        </div>

        {/* Form */}
        <div className="space-y-4">
          <Textarea
            label="Причина жалобы"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Опишите причину жалобы..."
            rows={5}
            maxLength={500}
            disabled={reportUser.isPending}
          />
        </div>

        {/* Actions */}
        <div className="mt-6 flex gap-3">
          <button
            onClick={onClose}
            disabled={reportUser.isPending}
            className="flex-1 h-12 text-neutral-400 hover:text-white font-medium text-sm transition-colors disabled:opacity-50"
          >
            Отмена
          </button>
          
          <button
            onClick={handleSubmit}
            disabled={reportUser.isPending || !reason.trim()}
            className="flex-1 h-12 bg-white text-black font-bold rounded-xl transition-all active:scale-95 disabled:opacity-30 disabled:cursor-not-allowed hover:bg-neutral-100"
          >
            {reportUser.isPending ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
                <span>Отправка...</span>
              </div>
            ) : (
              'Отправить'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;

